__turbopack_context__.v({
  "art": "article-art-module__E026fa__art",
  "number": "article-art-module__E026fa__number",
  "text": "article-art-module__E026fa__text",
});
